/**
 * This utility is needed to parse and validate JSON Web Tokens
 * submitted by the 'SatsConnectBitcoinProvider'.
 *
 * By doing that, we ensure that requests do not include unexpected (possible malicious) data and help
 * the TS compiler infer proper types.
 */
import { InvalidInputError } from '@exodus/web3-errors';
import { validateGetAddressOptions, validateSignTransactionOptions, validateSendBtcTransactionOptions, validateSignMessageOptions, } from './validator.js';
const decodeJWT = (token) => {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString('utf-8'));
};
// https://github.com/secretkeylabs/sats-connect/blob/9f0d3f417416d5979ce531dd8e65f91e0e5ac79a/src/addresses/index.ts#L7-L6.
export const parseAndValidateGetAddressOptions = (token) => {
    let payload;
    try {
        payload = validateGetAddressOptions(decodeJWT(token));
    }
    catch (err) {
        throw new InvalidInputError();
    }
    if (!payload.purposes || payload.purposes.length === 0) {
        throw new InvalidInputError('Purposes should be a non-empty array.');
    }
    return payload;
};
export const parseAndValidateSignTransactionOptions = (token) => {
    return validateSignTransactionOptions(decodeJWT(token));
};
export const parseAndValidateSignMessageOptions = (token) => {
    return validateSignMessageOptions(decodeJWT(token));
};
export const parseAndValidateSendBtcTransactionOptions = (token) => {
    return validateSendBtcTransactionOptions(decodeJWT(token));
};
